import { motion } from "motion/react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { errors, usePrefixedRouting } from "@ryde/shared";

import { NotFoundPageStyled } from "./not-found.page.styled";

interface INotFoundPageProps {
  addInfo?: string;
}

export const NotFoundPage: FC<INotFoundPageProps> = () => {
  const { prefix } = usePrefixedRouting();
  const { t } = useTranslation();

  return (
    <NotFoundPageStyled>
      <motion.div
        className="not-found__block"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <span className="emoji" role="img" aria-label="Confused face">
          😕
        </span>
        <h1>{`404 – ${t(errors.common.pageNotFound)}`}</h1>
        <p>{t(errors.common.pageNotFoundDescription)}</p>
        <Link className="not-found__return-link" to={prefix}>
          {t(errors.common.returnToMainPage)}
        </Link>
      </motion.div>
    </NotFoundPageStyled>
  );
};
